import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Header from "../../layouts/Header";
import "../../assets/styles/local/OrderPickingList.css";
import "../../assets/styles/local/asc_Custom_Select_Box.css";
import smallDownArrow from "../../assets/icons/DownArrowOption.svg";
import calendar from "../../assets/icons/Calendar3.svg";
import Kebab from "../../assets/icons/Kebab Calculations.svg";
import pdfIcon from "../../assets/icons/Pdf icon.svg";
import CSVIcon from "../../assets/icons/SCVdocument.svg";
import DeleteIcon from "../../assets/icons/Bin.svg";
import "../../assets/styles/local/Equipment.css";
import {
  DeleteCountStock,
  FetchCountStockReport,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import AppDatePicker from "../Common/AppDatePicker";
import DeletePopUp from "../Dailogs/DeletePopUp";
import Pagination from "../Pagination/Pagination";
import { formattedCurrency } from "../../utils/helpers/calculateTime";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { usePDF } from "react-to-pdf";
import { CSVLink } from "react-csv";

const headers = [
  { label: "Date of Count", key: "date" },
  { label: "No. Items Counted", key: "count" },
  { label: "Qty Difference", key: "qtyDiff" },
  { label: "Value Difference", key: "valueDiff" },
];

const CountStockReport = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [openStock, setOpenStock] = useState(false);
  const [startCalendarIsOpen, setStartCalendarOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endCalendarIsOpen, setEndCalendarOpen] = useState(false);
  const [endDate, setEndDate] = useState(new Date());
  const [listData, setListData] = useState([]);
  const [openMenu, setOpenMenu] = useState("");
  const [DeleteModal, setDeleteModal] = useState(false);
  const [query, setQuery] = useState("");
  const [deleteRowIndex, setDeleteRowIndex] = useState(null);
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const fetchStockReportRes = useSelector(
    (state) => state.user.fetchCountStockReportRes,
  );
  const deleteStockReportRes = useSelector(
    (state) => state.user.deleteCountStockReportRes,
  );
  const { toPDF, targetRef } = usePDF({ filename: "stock-report.pdf" });

  useEffect(() => {
    const startDateVal = startDate.toISOString().split("T")[0];
    dispatch(
      FetchCountStockReport(
        startDateVal,
        endDate,
        perPage,
        currentPage + 1,
        query,
      ),
    );
  }, [
    currentPage,
    dispatch,
    query,
    startDate,
    endDate,
    deleteStockReportRes,
    perPage,
  ]);

  useEffect(() => {
    setCurrentPage(0);
  }, [query, perPage]);

  useEffect(() => {
    if (fetchStockReportRes != null && fetchStockReportRes?.data) {
      const totalRecords = fetchStockReportRes?.data?.totalCount;
      const newTotalPages = Math.ceil(totalRecords / perPage);
      setTotalPages(newTotalPages);
      setListData(fetchStockReportRes?.data?.productsParts);
    }
  }, [fetchStockReportRes, query, startDate, endDate]);

  useEffect(() => {
    if (deleteStockReportRes != null && deleteStockReportRes?.status) {
    }
  }, [deleteStockReportRes]);

  const handleDelete = () => {
    dispatch(DeleteCountStock(deleteRowIndex));
    setDeleteModal(false);
    setOpenMenu("");
  };

  useEffect(() => {
    fetchScreenTranslations("Stock Levels").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const csvData = listData.map((item) => ({
    date: `${item.dateOfCount.split("T")[0]}`,
    count: item.itemcounted,
    qtyDiff: item.quantityDiff,
    valueDiff: item.valueDifference
      ? formattedCurrency(item.valueDifference)
      : "€ 0,00",
  }));

  return (
    <>
      <Header
        leftComponent={
          <div
            className="stock-heading-box"
            style={{ alignItems: "flex-start" }}
          >
            <div
              className="stock-heading cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>
            <div>
              <div
                className="box-title d-flex flex-column position-relative product_stock_entry_title_report pointer"
                style={{
                  border: "0.5px solid #e0dada",
                  borderRadius: "8px",
                  height: "50px",
                }}
                onClick={() => setOpenStock(!openStock)}
              >
                <div className="d-flex justify-content-between w-100 align-items-center">
                  <span>{t("Stock Levels - Report")}</span>
                  <img
                    alt=""
                    src={smallDownArrow}
                    style={{
                      opacity: "60%",
                      width: "16px",
                      height: "12px",
                      transform: openStock ? "rotate(180deg)" : "rotate(0deg)",
                      cursor: "pointer",
                    }}
                  />
                </div>
                {openStock && (
                  <span
                    style={{
                      top: "50px",
                      left: "0",
                      border: "0.5px solid #e0dada",
                      borderRadius: "8px",
                    }}
                    className="box-title align-self-start cursor-pointer  font-weight-normal position-absolute product_stock_entry_title_report"
                    onClick={(e) => {
                      e.stopPropagation();
                      history.push("/stock-levels-single");
                    }}
                  >
                    {t("Stock Levels - Entry")}
                  </span>
                )}
              </div>
            </div>
          </div>
        }
        setQuery={setQuery}
      />
      <div>
        <div className="ps-5 d-flex gap-4 flex-wrap">
          <div className="d-flex align-items-center gap-2">
            <p className="pick_project pt-3">
              {/* Date of Count */}
              {t("Date of Count")}
            </p>
            <div className="align-items-center item-output d-flex border-0 gap-2 ">
              <img
                className="calendarIcon"
                onClick={() => setStartCalendarOpen((p) => !p)}
                src={calendar}
                alt=""
              />
              <AppDatePicker
                inputClassNames={"background-color-transparent"}
                open={startCalendarIsOpen}
                onOpenChange={(open) => setStartCalendarOpen(open)}
                selected={startDate}
                onChange={(val) => {
                  setStartDate(val);
                  setStartCalendarOpen(false);
                }}
                onSelect={(d, event) => {
                  event.preventDefault();
                }}
                dateFormat="dd/MM/yyyy"
              />
            </div>
          </div>

          <div className="d-flex align-items-center gap-2">
            <p className="pick_project pt-3">
              {/* Ending Date */}
              {t("Ending Date")}
            </p>
            <div className="align-items-center item-output d-flex border-0 gap-2 ">
              <img
                className="calendarIcon"
                onClick={() => setEndCalendarOpen((p) => !p)}
                src={calendar}
                alt=""
              />
              <AppDatePicker
                inputClassNames={"background-color-transparent"}
                open={endCalendarIsOpen}
                onOpenChange={(open) => setEndCalendarOpen(open)}
                selected={endDate}
                onChange={(val) => {
                  setEndDate(val);
                  setEndCalendarOpen(false);
                }}
                onSelect={(d, event) => {
                  event.preventDefault();
                }}
                dateFormat="dd/MM/yyyy"
              />
            </div>
          </div>

          <div className="ms-auto me-1 me-sm-5 d-flex flex-wrap gap-3 pt-2 threeButtons align-items-center">
            <p className="pick_project pt-3">
              {/* Export All */}
              {t("Export All")}
            </p>

            <img
              className="calendarIcon pointer"
              src={pdfIcon}
              alt=""
              onClick={() => toPDF()}
            />

            <CSVLink
              filename={"stock-report.csv"}
              data={csvData}
              headers={headers}
              style={{ textDecoration: "none" }}
            >
              <section>
                <img className="calendarIcon pointer" src={CSVIcon} alt="" />
              </section>
            </CSVLink>
          </div>
        </div>
      </div>
      <div>
        <section className="pt-3">
          <div
            className="ascTableWrapper pt-3 mx-5"
            style={{ borderRadius: "15px", minHeight: "70vh" }}
          >
            <table className="table" ref={targetRef}>
              <thead>
                <tr className="tableHeading-NewInvoice">
                  <th>
                    {/* Date of Count */}
                    {t("Date of Count")}
                  </th>
                  <th>
                    {/* No. Items Counted */}
                    {t("No. Items Counted")}
                  </th>
                  <th>
                    {/* Qty Difference */}
                    {t("Qty Difference")}
                  </th>
                  <th>
                    {/* Value Difference */}
                    {t("Value Difference")}
                  </th>
                </tr>
              </thead>
              <tbody
                className="tabLine"
                style={{ borderTop: "none", background: "white" }}
              >
                {listData.map((item, index) => {
                  return (
                    <tr
                      key={item.stockCountId}
                      className="TableRowClass bg-transparent"
                    >
                      <td>{item.dateOfCount.split("T")[0]}</td>
                      <td>{item.itemcounted}</td>
                      <td>{item.quantityDiff}</td>
                      <td>
                        {item.valueDifference
                          ? formattedCurrency(item.valueDifference)
                          : "€ 0,00"}
                      </td>
                      <td style={{ position: "relative" }}>
                        <div className="d-flex justify-content-end ">
                          <img
                            src={Kebab}
                            alt="menu icon"
                            className="quote-menu-icon"
                            style={{
                              transitionDuration: "300ms",
                              transform: openMenu === index && "rotate(-90deg)",
                            }}
                            onClick={() => {
                              if (openMenu === index) {
                                setOpenMenu("");
                              } else {
                                setOpenMenu(index);
                              }
                            }}
                          />
                          <section
                            className="drop-down-menu"
                            style={{
                              transform:
                                openMenu === index ? "scale(1)" : "scale(0)",
                              transitionDuration: "300ms",
                            }}
                          >
                            <div className="menu-icon-cont">
                              <img
                                src={Kebab}
                                alt="menu icon"
                                className="quote-menu-icon inside-menu"
                                style={{
                                  transform: "rotate(-90deg)",
                                }}
                                onClick={() => {
                                  if (openMenu === index) {
                                    setOpenMenu("");
                                  } else {
                                    setOpenMenu(index);
                                  }
                                }}
                              />
                            </div>
                            <div className="quote-menu-list fc">
                              <section
                                className="fr menu-single-item count-menu"
                                style={{ gap: "10px" }}
                                // onClick={() => toPDF()}
                                onClick={() => {
                                  setOpenMenu("");
                                  setTimeout(() => {
                                    toPDF();
                                  }, 1000);
                                }}
                              >
                                <img src={pdfIcon} alt="Menu Icons" />
                                <p>
                                  {/* Export to PDF */}
                                  {t("Export to PDF")}
                                </p>
                              </section>

                              <CSVLink
                                filename={"stock-report.csv"}
                                data={csvData}
                                headers={headers}
                                style={{ textDecoration: "none" }}
                                onClick={() => {
                                  setOpenMenu("");
                                }}
                              >
                                <section
                                  className="fr menu-single-item count-menu"
                                  style={{ gap: "10px" }}
                                >
                                  <img src={CSVIcon} alt="Menu Icons" />
                                  <p>
                                    {/* Export to Excel */}
                                    {t("Export to Excel")}
                                  </p>
                                </section>
                              </CSVLink>
                              <section
                                onClick={() => {
                                  setDeleteModal(true);
                                  setDeleteRowIndex(item.stockCountId);
                                }}
                                className="fr menu-single-item count-menu"
                                style={{ gap: "10px" }}
                                key={item.stockCountId}
                              >
                                <img src={DeleteIcon} alt="Menu Icons" />
                                <p>
                                  {/* Delete */}
                                  {t("Delete")}
                                </p>
                              </section>
                            </div>
                          </section>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {listData.length > 0 && (
            <div className="align-text-bottom stock-pagination mx-5">
              <Pagination
                perPage={perPage}
                setPerPage={setPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
              />
            </div>
          )}
        </section>
      </div>
      {DeleteModal && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDelete}
          show={DeleteModal}
          onHide={() => setDeleteModal(false)}
          title1={"This data will be removed from the system"}
          title2={"and cannot be undone."}
          title3={"Do you want to proceed?"}
          no={"No"}
          yes={"Yes"}
        />
      )}
    </>
  );
};

export default CountStockReport;
